import React, { useMemo } from 'react';
import { View } from 'react-native';
import Stack from '../../../../../v2BaseComponents/Stack';
import { BulkAddClientRecord, csvHeaders, propFromHeader } from '../types';
import { colors } from '../../../../../../utils/theme';
import Text from '../../../../../v2BaseComponents/Text';
import { columnWidths } from './constants';
import { getRowErrors } from './utils';

export type HeadersOwnProps = {
    firstRowValues?: BulkAddClientRecord;
};

export type HeadersProps = HeadersOwnProps;

const Headers: React.FC<HeadersProps> = (props) => {
    const firstRowErrors = useMemo(
        () => (props.firstRowValues ? getRowErrors(props.firstRowValues) : []),
        [props.firstRowValues],
    );
    const getNextHasError = (index: number) => !!firstRowErrors[index];

    return (
        <Stack horizontal>
            {csvHeaders.map((header, index) => (
                <View
                    style={{
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        padding: 4,
                        height: 30,
                        borderWidth: 1,
                        borderColor: colors.Dividers,
                        borderRightWidth: index === csvHeaders.length - 1 ? undefined : 0,
                        borderBottomColor: getNextHasError(index) ? colors.Alert : colors.Dividers,
                        width: columnWidths[propFromHeader(header)],
                        backgroundColor: colors.Background,
                    }}
                    key={index}
                >
                    <Text variant="table-header">{header}</Text>
                </View>
            ))}
        </Stack>
    );
};

export default React.memo(Headers);
